/* global bcejwt */
import Vue from "vue";
import Router from "vue-router";
import MyHome from "./components/books/views/MyHome";
import Sidebar from "./components/events/components/Sidebar";
import SidebarEvents from "./components/events/components/SidebarEvents";
import EventsDownload from "./components/events/views/EventsDownload";
import EventsDownloadCertificate from "./components/events/views/EventsDownloadCertificate";
import EventsEditLaboratories from "./components/events/views/EventsEditLaboratories";
import EventsList from "./components/events/views/EventsList";
import EventsMain from "./components/events/views/EventsMain";
import EventsPersonalData from "./components/events/views/EventsPersonalData";
import EventsSelectedEvent from "./components/events/views/EventsSelectedEvent";
import EventsSurvey from "./components/events/views/EventsSurvey";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      component: MyHome,
      children: [
        {
          path: "",
          component: EventsMain,
          children: [
            {
              path: "",
              name: "events",
              component: EventsList,
              props: {
                mainTitle: "I miei prossimi corsi",
                sidebarComponent: SidebarEvents,
                headerSecondaryTitle: "Vai all'Area Personale Deascuola",
                headerSecondaryUrl: "#/",
                headerSecondaryExtraTitle: "Vai a Deascuola Formazione",
                headerSecondaryExtraUrl: "https://formazione.deascuola.it/",
              },
            },
            {
              path: "dati/:registration/",
              name: "personal-data",
              component: EventsPersonalData,
              props: {
                mainTitle: "Completa il questionario",
                sidebarComponent: Sidebar,
                headerSecondaryTitle: "Torna all'Area Personale",
                headerSecondaryUrl: "#/",
                headerSecondaryExtraTitle: "Vai a Deascuola Formazione",
                headerSecondaryExtraUrl: "https://formazione.deascuola.it/",
                updateUser: true,
              },
            },
            {
              path: "questionario/:registration/",
              name: "survey",
              component: EventsSurvey,
              props: {
                mainTitle: "Questionario di valutazione",
                sidebarComponent: Sidebar,
                headerSecondaryTitle: "Torna all'Area Personale",
                headerSecondaryUrl: "#/",
                headerSecondaryExtraTitle: "Vai a Deascuola Formazione",
                headerSecondaryExtraUrl: "https://formazione.deascuola.it/",
              },
            },
            {
              path: "certificati/:registration/",
              name: "certificate",
              component: EventsDownloadCertificate,
              props: {
                mainTitle: "Grazie!",
                sidebarComponent: Sidebar,
                headerSecondaryTitle: "Torna all'Area Personale",
                headerSecondaryUrl: "#/",
                headerSecondaryExtraTitle: "Vai a Deascuola Formazione",
                headerSecondaryExtraUrl: "https://formazione.deascuola.it/",
              },
            },
            {
              path: "laboratori/:registration/",
              name: "laboratories",
              component: EventsEditLaboratories,
              props: {
                mainTitle: "Modifica laboratori",
                sidebarComponent: Sidebar,
                headerSecondaryTitle: "Torna all'Area Personale",
                headerSecondaryUrl: "#/",
                headerSecondaryExtraTitle: "Vai a Deascuola Formazione",
                headerSecondaryExtraUrl: "https://formazione.deascuola.it/",
              },
            },
            {
              path: "documenti/:registration/",
              name: "download",
              component: EventsDownload,
              props: {
                mainTitle: "Scarica i materiali",
                sidebarComponent: Sidebar,
                headerSecondaryTitle: "Torna all'Area Personale",
                headerSecondaryUrl: "#/",
                headerSecondaryExtraTitle: "Vai a Deascuola Formazione",
                headerSecondaryExtraUrl: "https://formazione.deascuola.it/",
              },
            },
            {
              path: "iscrizione/:registration/",
              name: "registration",
              component: EventsSelectedEvent,
              props: {
                mainTitle: "Il mio corso",
                sidebarComponent: Sidebar,
                headerSecondaryTitle: "Torna all'Area Personale Deascuola",
                headerSecondaryUrl: "#/",
                headerSecondaryExtraTitle: "Torna ai miei corsi",
                headerSecondaryExtraUrl: "#/",
              },
            },
          ],
        },
      ],
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

bcejwt.setAutoRedirectToLogin(true);

router.afterEach(to => {
  // FIXME: Da controllare
  bcejwt.checkLogin("onIdentification");
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "pageviewCustomEvent",
      pagePath: `${to.path}`,
      pageTitle: `Area Personale - ${to.name}`,
    });
  }
});

export default router;
